Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ShuffleArray = void 0;
var ShuffleArray = exports.ShuffleArray = function ShuffleArray(origArray) {
  var a = origArray.slice();
  do {
    for (var i = a.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var _ref = [a[j], a[i]];
      a[i] = _ref[0];
      a[j] = _ref[1];
    }
  } while (JSON.stringify(a) === JSON.stringify(origArray));
  return a;
};